import React from 'react';
import { useTranslation } from 'react-i18next';

import AgentNotification from 'models/agent_notification';
import connect from 'components/lib/connect';
import { Item, Text, Timestamp } from './shared_notification';
import MarkAgentNotificationAsRead from 'actions/agent_notifications/mark_agent_notification_as_read';
import NavigateToItem from 'actions/conversation_item/navigate_to_item';
import { useExecuteAction } from 'components/hooks/connect_hooks';

function TaskCommented({ agent, notification }) {
  const { t } = useTranslation();
  const executeAction = useExecuteAction();

  const onClick = () => {
    executeAction(MarkAgentNotificationAsRead, { id: notification.id });
    executeAction(NavigateToItem, { customerId: notification.content.customerId, itemId: notification.content.taskId });
  };

  const agentName = agent ? agent.name : t('An agent');
  const objectText = getObjectText(notification, t);
  return (
    <Item onClick={onClick}>
      <Text hasRead={notification.hasRead()}>
        {t('{{agentName}} commented on a task {{objectText}}', { agentName, objectText })}
      </Text>
      <Timestamp timestamp={notification.createdAt} />
    </Item>
  );
}

function getObjectText(notification, t) {
  if (notification.type === AgentNotification.Type.FOLLOWED_TASK_COMMENTED) {
    return t('you follow');
  } else if (notification.type === AgentNotification.Type.ASSIGNED_TASK_COMMENTED) {
    return t('assigned to you');
  }
  return '';
}

const TaskCommentedContainer = connect(mapStateToProps)(TaskCommented);

function mapStateToProps({ getProvider }, { notification }) {
  return {
    agent: getProvider('agents').findBy({ id: notification.initiator.id }),
  };
}

export default TaskCommentedContainer;
